export const SECONDS_PER_HOUR = 3600

export const formatTime = (timeInSeconds: number): string => {
  const hours = Math.floor(timeInSeconds / SECONDS_PER_HOUR)
  const minutes = Math.floor((timeInSeconds % SECONDS_PER_HOUR) / 60)
  const seconds = Math.floor(timeInSeconds % 60)

  if (hours > 0) {
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
  }
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
}

export const formatSeekTime = (timeInSeconds: number): string => {
  const milliseconds = Math.max(0, Math.round(timeInSeconds * 1000))
  return `${formatTime(milliseconds / 1000)}.${String(milliseconds % 1000).padStart(3, "0")}`
}
